import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";

import { DashboardService } from "../dashboard.service";
import { finalize } from "rxjs/operators";
import { indicate } from "maps-angular-components";

@Component({
  selector: "app-panel-header",
  templateUrl: "./panel-header.component.html",
  styleUrls: ["./panel-header.component.scss"],
})
export class PanelHeaderComponent implements OnInit {

  @Output() onRefreshClick: EventEmitter<any> = new EventEmitter<any>();

  upCountOptions = { startVal: 0, separator: "." };
  refreshDate: Date;
  quantidadeTotalRegras$ = new Observable<number>();
  loadingTotalRegras$ = new Subject<boolean>();

  quantidadeTotalCarteiras$ = new Observable<number>();
  loadingTotalCarteiras$ = new Subject<boolean>();

  constructor(
    private dashboardService: DashboardService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.refreshValues();
  }

  refreshValues() {

    this.quantidadeTotalRegras$ = this.dashboardService
      .getQuantidadeTotalRegras()
      .pipe(
        indicate(this.loadingTotalRegras$),
        finalize(() => (this.refreshDate = new Date()))
      );

    this.quantidadeTotalCarteiras$ = this.dashboardService
      .getQuantidadeTotalCarteiras()
      .pipe(
        indicate(this.loadingTotalCarteiras$),
        finalize(() => (this.refreshDate = new Date()))
      );

    this.changeDetectorRef.detectChanges();
  }

  emitterOnRefresh() {
    this.onRefreshClick.emit();
    this.refreshValues();
    this.changeDetectorRef.detectChanges();
  }
}
